// Store
import { useTemplateStore } from "@/zustand/templateStore";

// Assets
import { ProductUnchecked, ProductChecked } from "@/assets/Icons";

export interface ProductCardProps {
  product: {
    amount?: number;
    display_name?: string;
    image?: { url?: string };
    best_seller?: boolean;
    best_value?: boolean;
    status?: string;
    tr_best_value_status?: string;
    formatted_old_price?: string;
    formatted_price?: string;
    you_save_percentage?: string | number;
    tr_additional_texts?: string;
    show_additional_text_info?: boolean;
  };
  active: boolean;
  handleChange: (index: number) => void;
  index: number;
}

export default function ProductCard({
  product,
  active,
  handleChange,
  index,
}: ProductCardProps) {
  const { productList, settings } = useTemplateStore();

  const hasBestSeller = product?.best_seller === true;
  const hasBestValue = product?.best_value === true;

  const showTags = hasBestSeller || hasBestValue;

  return (
    <div
      className={`shadow-cc-2 flex flex-col gap-2.5 rounded-sm p-2 md:p-4 ${
        settings.enable_high_contrast
          ? active
            ? "border-cc-blue-3 bg-cc-light-gray-2 border-2"
            : "border-cc-gray-5 border"
          : active
            ? "border-cc-violet bg-cc-light-gray-2 border"
            : "border-cc-gray-4 border"
      } `}
      onClick={() => handleChange(index)}
    >
      {showTags && (
        <div>
          {hasBestSeller && (
            <span
              className={`font-poppins rounded-sm px-4 py-1 text-xs font-bold text-white uppercase ${
                settings.enable_high_contrast ? "bg-cc-blue-3" : "bg-cc-blue"
              }`}
            >
              {productList?.tr_best_seller_label || "Best Seller"}
            </span>
          )}
          {hasBestValue && (
            <span
              className={`bg-cc-yellow-2 font-poppins rounded-sm px-4 py-1 text-xs font-bold uppercase ${
                settings.enable_high_contrast
                  ? "text-cc-dark-gray"
                  : "text-cc-gray"
              }`}
            >
              {productList?.tr_best_value_label || "Best Value"}
            </span>
          )}
        </div>
      )}
      <div className="flex justify-between gap-2">
        <div className="flex items-center gap-4">
          <div className="hidden md:block">
            {active ? (
              <ProductChecked contrast={settings.enable_high_contrast} />
            ) : (
              <ProductUnchecked contrast={settings.enable_high_contrast} />
            )}
          </div>
          <img
            src={product?.image?.url}
            className="size-14 md:size-[85px]"
            alt={product?.display_name || "Product Image"}
          />
          <div className="flex flex-col gap-1">
            <div
              className={`text-base font-bold md:text-xl ${
                settings.enable_high_contrast
                  ? "text-cc-dark-gray"
                  : "text-cc-gray"
              }`}
            >
              {product?.amount}x {product?.display_name}
            </div>
            {product?.show_additional_text_info && (
              <span className="text-cc-gray text-xs md:text-base">
                {product?.tr_additional_texts}
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-col items-end justify-center gap-1">
          <div
            className={`text-xs line-through md:text-sm ${
              settings.enable_high_contrast
                ? "text-cc-red"
                : "text-cc-dark-red-2"
            }`}
          >
            {product?.formatted_old_price}
          </div>

          <div className="text-cc-green text-sm font-black md:text-lg">
            {product?.you_save_percentage}% {productList?.tr_discount_off_label}
          </div>
          <div
            className={`text-right text-sm font-bold md:text-lg ${
              settings.enable_high_contrast
                ? "text-cc-dark-gray"
                : "text-cc-gray"
            }`}
          >
            <span className="inline text-base whitespace-nowrap md:text-xl">
              {productList?.tr_price_only_label} {product?.formatted_price}
            </span>{" "}
            <span className="block text-right text-xs md:inline md:text-xl">
              {productList?.tr_price_each_label}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
